import { useEffect, useState } from 'react';
import { AuraTheme, ThemeName, loadTheme } from '../aura';
import { useIsMounted } from './use-is-mounted';

export function useTheme(): AuraTheme | null {
  const isMounted = useIsMounted();
  const [theme, setTheme] = useState<AuraTheme | null>(null);

  useEffect(() => {
    loadTheme(ThemeName.TW_PRO).then(t => {
      if (isMounted.current) {
        setTheme(t);
      }
    });
  }, [isMounted]);

  return theme;
}
